import { render, staticRenderFns } from "./OtpInputer.vue?vue&type=template&id=7da74f8a"
import script from "./OtpInputer.vue?vue&type=script&lang=js"
export * from "./OtpInputer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports